import { useIsPermittedTo } from "contexts/session";

const WhenPermitted = ({ children, to: permissionKey }) => {
  const permitted = useIsPermittedTo(permissionKey);
  if (permitted) return children;
  return null;
};
export default WhenPermitted;
